import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'

import PList from './views/Plist.vue'

import Detail from './views/detail.vue'

import ADbanner from './views/ADbanner.vue'
import ADdelivery from './views/ADdelivery.vue'

import aldListDetail from './views/ALDlistDetail'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        leaf:true,
        component: Home,
        redirect:'product/index',
        name: '产品管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: 'product/index', component: PList, name: '产品管理' },
            { path: 'product/detail/:name', component: Detail, name: '产品详情' },
            { path: 'space/index', component: ADbanner, name: '广告位' },
            { path: 'plan/index', component: ADdelivery, name: '广告投放' },
            { path: 'shieldAld/index/:index_id', component: aldListDetail, name: '扣量规则详情' },
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js